import { render, staticRenderFns } from "./DeleteLocationForm.vue?vue&type=template&id=ad0b2844&scoped=true"
import script from "./DeleteLocationForm.vue?vue&type=script&lang=ts"
export * from "./DeleteLocationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0b2844",
  null
  
)

export default component.exports